import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { isNullOrEmpty, translate, convertToUppercase } from '../../../utils/util';
import { onValueChange } from '../../../utils/handleChangeHooks';
import { ENUMS, VISIONS } from '../../../utils/constants';
import { Select, Input, Button, BackButton, Title, Subtitle, SelectDock } from '../../../components/UI/ComponentsUI';
import * as actionsPhysicalConfirmation from '../../../actions/physicalConfirmationAction';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { getVision } from '../../../services/auth';

const ReprocessEdit = (props) => {
    const [confirmation, setConfirmation] = useState({});

    useEffect(() => {
        if (props.location?.state?.item) {
            const { item } = props.location.state;
            const lastTransmission = item.transmissions ? item.transmissions.slice(-1)[0] : {}

            var confirmationProps = item

            confirmationProps.boxQuantity = item.boxQuantity ? item.boxQuantity : lastTransmission?.boxQuantity
            confirmationProps.boxQuantityItems = item.boxQuantityItems ? item.boxQuantityItems : lastTransmission?.boxQuantityItems
            confirmationProps.place = "1";
            confirmationProps.preAllocationArea = "%";
            confirmationProps.print = item.print || lastTransmission?.print || getPrint()
            confirmationProps.resourceId = item.resourceId === undefined ? onChangeResource(lastTransmission?.resource) : item.resourceId

            props.setPrintSelect(confirmationProps.print)

            confirmationProps.lastMessage = lastTransmission.message

            setConfirmation({ ...confirmationProps });
        }

        // eslint-disable-next-line
    }, []);

    const getPrint = () => {
        if (getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
            return ENUMS.ePrintTypes.Click.value
        } else {
            return ENUMS.ePrintTypes.Logistics.value
        }
    }

    const onChangeResource = (resource) => {
        if (resource != null) {
            return props.resources.find((i) => i.name === resource)?.resourceId
        } else if (!isNullOrEmpty(props.user.resource)) {
            return props.resources.find((i) => i.resourceId === parseInt(props.user.resource))?.resourceId
        }
        return props.resources[0]?.resourceId;
    }

    const onChange = (event) => {
        onValueChange(event, confirmation, setConfirmation);
    };

    const onConfirm = () => {
        const listReceipts = props.receipts;
        const index = listReceipts.findIndex(x => x.id === confirmation.id)

        confirmation.adjusted = true;
        if (index > -1) listReceipts[index] = confirmation;

        props.updateReceipt(listReceipts)

        props.history.go(-1)
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-clipboard-list-outline" label={translate('reprocess-monitor', 'physical-confirmation')} />
                <Subtitle icon="mdi mdi-clipboard-list-outline" label={translate('change', 'physical-confirmation')} />
            </div>
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container" style={{ width: '96%' }}>
                    <div className="card">
                        <div className="card-content" style={{ padding: '5px', paddingBlockEnd: '1px' }}>
                            <div className="no-padding" style={{ marginBottom: '30px' }}>
                                <span className="sixth-text-color" style={{ display: 'block' }}>{confirmation.partNumberCode || ''}</span>
                                <span className="fourth-text-color" style={{ display: 'block' }}>{confirmation.lastMessage || 'Erro não especificado.'}</span>
                            </div>
                            <form style={{ marginBottom: '20px' }}>
                                <div className="row">
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            id="boxQuantity"
                                            name="boxQuantity"
                                            className="required"
                                            required
                                            aria-required="true"
                                            type="number"
                                            defaultValue={confirmation.boxQuantity || ''}
                                            onChange={onChange}
                                            onBlur={onChange}
                                            min={1}
                                            maxLength="6"
                                            step="1"
                                            label={translate('volume', 'physical-confirmation')}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="mdr"
                                            name="mdr"
                                            type="text"
                                            required
                                            defaultValue={confirmation.mdr || ''}
                                            onChange={onChange}
                                            maxLength="5"
                                            label={translate('physical-confirmation:mdr')}
                                            onKeyUp={convertToUppercase}
                                        />
                                    </div>
                                    <div className="input-field col s11 no-padding">
                                        <Input
                                            id="boxQuantityItems"
                                            name="boxQuantityItems"
                                            className="required"
                                            required
                                            aria-required="true"
                                            type="number"
                                            defaultValue={confirmation.boxQuantityItems || ''}
                                            onChange={onChange}
                                            onBlur={onChange}
                                            min={1}
                                            maxLength="10"
                                            label={translate('partnumber', 'physical-confirmation')}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Select
                                            id="place"
                                            name="place"
                                            notOption
                                            display="description"
                                            defaultValue={confirmation.place || '1'}
                                            change={onChange}
                                            data={[
                                                { id: "1", text: translate('storage', 'physical-confirmation') },
                                                { id: "2", text: translate('entrance-area', 'physical-confirmation') },
                                            ]}
                                        />
                                    </div>
                                    {confirmation.place === "1" &&
                                        <div className="input-field no-padding col s6">
                                            <div className="input-field" style={{ marginTop: '13px' }}>
                                                <Input
                                                    id="preAllocationArea"
                                                    name="preAllocationArea"
                                                    className="required"
                                                    required
                                                    type="text"
                                                    defaultValue={confirmation.preAllocationArea}
                                                    onChange={onChange}
                                                    label={translate('pre-allocation-area', 'physical-confirmation')}
                                                    onKeyUp={convertToUppercase}
                                                />
                                            </div>
                                        </div>
                                    }
                                    {
                                    getVision() === VISIONS.Jeep && confirmation.place === "2" &&
                                        <div className="input-field no-padding col s5">
                                            <div className="input-field" style={{ marginTop: '13px' }}>
                                                <SelectDock
                                                    required={confirmation.place === 2}
                                                    id="preAllocationArea"
                                                    name="preAllocationArea"
                                                    filterArea
                                                    shedId={props.user.shed}
                                                    value={props.user.dock}
                                                    onChange={onChange}
                                                />
                                            </div>
                                        </div>
                                    }
                                    {
                                    getVision() !== VISIONS.Jeep && confirmation.place === "2" &&
                                        <div className="input-field col s5" style={{paddingTop: '21px', paddingLeft: '0px', paddingRight: '0px', paddingBottom: '0px'}}>
                                            <div className="input-field" style={{ marginTop: '13px' }}>
                                                <Input
                                                    required={confirmation.place === 2}
                                                    id="preAllocationArea"
                                                    name="preAllocationArea"
                                                    defaultValue={props.user.dock}
                                                    disabled
                                                    onKeyUp={convertToUppercase}
                                                />
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="row" style={{ paddingTop: '0px' }}>
                                    <div className="input-field col s5 no-padding" >
                                        <Select
                                            required
                                            id="print"
                                            name="print"
                                            display="name"
                                            notOption
                                            label={translate('print-type', 'physical-confirmation')}
                                            placeHolder={translate('choose-one-option', 'general')}
                                            data={[
                                                { id: ENUMS.ePrintTypes.Logistics.value, text: translate(ENUMS.ePrintTypes.Logistics.text, 'physical-confirmation') },
                                                { id: ENUMS.ePrintTypes.Click.value, text: translate(ENUMS.ePrintTypes.Click.text, 'physical-confirmation') },
                                                { id: ENUMS.ePrintTypes.NotPrint.value, text: translate(ENUMS.ePrintTypes.NotPrint.text, 'physical-confirmation') },
                                            ]}
                                            change={(e) => {
                                                props.setPrintSelect(e.target.value);
                                                onChange(e);
                                            }}
                                            defaultValue={props.printSelect}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <Select
                                            required
                                            id="resourceId"
                                            name="resourceId"
                                            valuefield="resourceId"
                                            display="name"
                                            notOption
                                            label={translate('resource', 'physical-confirmation')}
                                            placeHolder={translate('choose-one-option', 'general')}
                                            data={props.resources ? props.resources : []}
                                            defaultValue={confirmation.resourceId}
                                            change={onChange}
                                        />
                                    </div>
                                </div>
                            </form>
                            <div className="row">
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        transmissions: state.physicalConfirmationReducer.transmissions,
        resources: state.logisticsResourceReducer.list,
        user: state.userReducer.user,
        printSelect: state.physicalConfirmationReducer.printSelect,
        receipts: state.physicalConfirmationReducer.receipts,
        sheds: state.configReducer.sheds,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateReceipt: (receipts) => {
            dispatch(actionsPhysicalConfirmation.updateReceipt(receipts));
        },
        setPrintSelect: (printSelect) => {
            dispatch(PhysicalConfirmationService.setPrintSelect(printSelect));
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReprocessEdit)));